import React, { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  title?: ReactNode;
  titleClassName?: string;
  footer?: ReactNode;
  topRightAccessory?: ReactNode;
  onClick?: () => void; // Added onClick prop
}

export const Card: React.FC<CardProps> = ({ 
  children, 
  className = '', 
  title, 
  titleClassName = '', 
  footer, 
  topRightAccessory,
  onClick 
}) => {
  return (
    <div 
      className={`bg-white dark:bg-dark-secondary shadow-lg rounded-lg overflow-hidden flex flex-col print:shadow-none print:border print:border-gray-200 ${className}`}
      onClick={onClick} // Applied onClick prop
    >
      {title && (
        <div className={`p-4 border-b border-gray-200 dark:border-dark-tertiary flex justify-between items-center print:border-gray-200 ${titleClassName}`}>
          <h3 className="text-lg font-semibold text-gray-900 dark:text-dark-text-primary flex-grow flex items-center">{title}</h3>
          {topRightAccessory && <div className="ml-2 flex-shrink-0">{topRightAccessory}</div>}
        </div>
      )}
      <div className="p-4 md:p-6 flex-grow">
        {children}
      </div>
      {footer && (
        <div className="p-4 bg-white dark:bg-dark-secondary border-t border-gray-200 dark:border-dark-tertiary print:border-gray-200">
          {footer}
        </div>
      )}
    </div>
  );
};